angular.module('SpidApp')

.factory('StockFlowManager',
		[ 
function () {
	var StockFlowManager = {
			
		getReverseStockFlowsByProductGroupByOrderableId: function(stockProductArray, stockflowsArray) {
			
			return _.chain(stockflowsArray).filter(function(stockflow) {
	    		var stockProduct = _.find(stockProductArray, function(stockProduct) {
	    	    	return stockflow.orderable_id === stockProduct.product.id;
	        	});
	    		
	    		if (stockProduct) {
	    			stockflow.stockProduct = stockProduct;
	    			return true;
	    		}
	    		return false;
	    	}).sortBy(function (stockflow) {
	            return stockflow.updated_at
	        }).reverse().groupBy('orderable_id').value();
		}
	}

	return StockFlowManager
}])